module.exports = __webpack_public_path__ + "img/Functional_Area_Elements.615d7908.png";